import { useEffect, useState } from "react";
import { Printer, Music } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { staffApi } from "../lib/api";

export default function LoginCards() {
  const [data, setData] = useState(null);
  const [groupId, setGroupId] = useState("");
  const [groups, setGroups] = useState([]);

  useEffect(() => { staffApi.get("/staff/groups").then((r) => setGroups(r.data.groups)); }, []);
  useEffect(() => {
    staffApi.get(`/staff/login-cards${groupId ? `?group_id=${groupId}` : ""}`).then((r) => setData(r.data));
  }, [groupId]);

  return (
    <div className="space-y-6" data-testid="login-cards-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 print:hidden">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#0B192C]">Login cards</h1>
          <p className="text-sm text-[#566270] mt-1">Print and cut out. The QR code fills in the institution and username — never the PIN.</p>
        </div>
        <div className="flex gap-2">
          <select value={groupId} onChange={(e) => setGroupId(e.target.value)} data-testid="cards-group-filter"
            className="rounded-xl border-2 border-[#E5DEC9] bg-white px-4 py-3 min-h-[48px]">
            <option value="">All groups</option>
            {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
          </select>
          <button onClick={() => window.print()} data-testid="print-cards-btn"
            className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-[#C69B3D] text-[#0B192C] font-bold text-sm min-h-[48px]">
            <Printer className="w-4 h-4" /> Print
          </button>
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 print:grid-cols-2">
        {(data?.cards || []).map((c) => (
          <div key={c.username} className="rounded-2xl bg-white border-2 border-[#0B192C] p-5 break-inside-avoid" data-testid={`card-${c.username}`}>
            <div className="flex items-center gap-2 border-b border-[#E5DEC9] pb-3">
              <Music className="w-4 h-4 text-[#C69B3D]" aria-hidden />
              <span className="font-display font-bold text-[#0B192C]">ChoirQuest</span>
              <span className="ml-auto text-[10px] text-[#566270] uppercase tracking-wider">{c.institution_name}</span>
            </div>
            <p className="font-display text-lg font-bold text-[#0B192C] mt-3">{c.display_name}</p>
            <dl className="mt-2 space-y-1 text-sm">
              <div className="flex justify-between"><dt className="text-[#566270]">Institution</dt><dd className="font-note font-bold">{c.institution_code}</dd></div>
              <div className="flex justify-between"><dt className="text-[#566270]">Username</dt><dd className="font-note font-bold">{c.username}</dd></div>
              <div className="flex justify-between">
                <dt className="text-[#566270]">PIN</dt>
                <dd className="font-note font-bold text-[#7A1C2E]">{c.pin || "ask your choir staff"}</dd>
              </div>
            </dl>
            <div className="mt-3 flex justify-center">
              <QRCodeSVG value={c.qr_payload} size={72} fgColor="#0B192C" data-testid={`qr-${c.username}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
